import { useEffect } from 'react';
import './Thankyou.scss'
import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
const Thankyou = () => {

     const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.reload(); 
            navigate("/real-estate-website-builder");  
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);


    return (
        <Container fluid style={{backgroundColor:"#FEF9F9"}}>
            <div className="thankyou_main_wrapper">
                <div className="thankyou_upper_wrapper">
                    <h1 className="thankyou_heading">
                        Thank you!
                    </h1>
                    <p className="thankyou_text">
                        We’ve received your message and will get back to you shortly.
                    </p>
                    <p className="thankyou_text">
                        For urgent queries, drop us a mail at <a href="mailto:info@businessbay.io">info@businessbay.io</a>.
                    </p>
                </div>

                <div className="thankyou_lower_wrapper">
                        <Link to="/real-estate-website-builder" className="redbutton">
                            Back to Home
                        </Link>
                </div>
            </div>
        </Container>
    )
}

export default Thankyou